import type { StateCreator } from 'zustand'

export interface SkillSettingsSlice {
  allowAddNewSkill: boolean
  setAllowAddNewSkill: (val: boolean) => void
}

export const createSkillSettingsSlice: StateCreator<
  SkillSettingsSlice,
  [],
  [],
  SkillSettingsSlice
> = (set: Function) => ({
  allowAddNewSkill: true,
  setAllowAddNewSkill: (val: boolean) => set({ allowAddNewSkill: val })
})
